import { render, staticRenderFns } from "./indexCategory.vue?vue&type=template&id=ad169218&scoped=true&"
import script from "./indexCategory.vue?vue&type=script&lang=js&"
export * from "./indexCategory.vue?vue&type=script&lang=js&"
import style0 from "./indexCategory.vue?vue&type=style&index=0&id=ad169218&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad169218",
  null
  
)

export default component.exports